import { InfoCircleOutlined } from '@ant-design/icons';
import { Table, Tooltip } from 'antd';
import Ellipse from 'components/Global/Ellipse';
import { useSelector } from 'react-redux';
import { formatDate, formatNumber, invalidText } from 'utils/utils';
import styles from './index.module.scss';

const { Column } = Table;

type Props = {
	salaryData: any;
	totalRecords: number;
	currentPage: number;
	pageSize: number;
	tableChangeHandler: (pagination: any, filter: any, sorter: any) => void;
	isUSD?: boolean;
	isLoading: boolean;
};

const SalaryTable = (props: Props) => {
	const { data } = useSelector((state: any) => state?.userProfile);

	const {
		salaryData,
		totalRecords,
		currentPage,
		pageSize,
		isLoading,
		tableChangeHandler,
		isUSD,
	} = props;

	return (
		<div className={styles['dynamic-table']}>
			<Table
				dataSource={salaryData}
				scroll={{ y: 'calc(100vh - 350px)' }}
				pagination={{
					total: totalRecords,
					current: currentPage,
					pageSize: pageSize,
					showSizeChanger: false,
					// onShowSizeChange: pageSizeHandler,
					pageSizeOptions: [10, 20, 50, 100, 200],
				}}
				onChange={tableChangeHandler}
				rowKey={(record) => record.id}
				loading={isLoading}
			>
				<Column
					title="Monthly Salary"
					dataIndex="monthlySalary"
					className="bg-white"
					key="monthlySalary"
					width={'12%'}
					render={(value: string) => {
						if (isUSD) {
							return formatNumber(
								Number(value),
								data?.CompanyCurrencies,
								true
							);
						} else {
							return formatNumber(
								Number(value),
								data?.CompanyCurrencies
							);
						}
					}}
					// sorter={true}
				/>
				<Column
					title="Pay Period"
					dataIndex="payperiodName"
					key="payperiodName"
					width={'20%'}
					className="bg-white"
				/>
				<Column
					title="Mid Month Pay"
					dataIndex="midMonthSalary"
					key="midMonthSalary"
					className="bg-white"
					render={(value: string, record: any) => {
						let number = '';
						if (isUSD) {
							number = formatNumber(
								Number(value),
								data?.CompanyCurrencies,
								true
							);
						} else {
							number = formatNumber(
								Number(value),
								data?.CompanyCurrencies
							);
						}
						return (
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
								}}
							>
								<span>{number}</span>
								{!record.carryForwardMidMonth && (
									<Tooltip title="Mid-month salary will not carry forward to the next pay period. Latest entry will be effective.">
										<InfoCircleOutlined
											style={{
												marginLeft: 8,
												color: '#584495',
												cursor: 'pointer',
											}}
										/>
									</Tooltip>
								)}
							</div>
						);
					}}
				/>

				<Column
					title="Hourly Salary"
					dataIndex="hourlySalary"
					key="hourlySalary"
					className="bg-white"
					render={(value: string) => {
						if (isUSD) {
							return formatNumber(
								Number(value),
								data?.CompanyCurrencies,
								true
							);
						} else {
							return formatNumber(
								Number(value),
								data?.CompanyCurrencies
							);
						}
					}}
				/>
				{isUSD && (
					<Column
						title="Net Pay"
						dataIndex="netPay"
						key="netPay"
						className="bg-white"
						render={(value: string) => {
							if (isUSD) {
								return formatNumber(
									Number(value),
									data?.CompanyCurrencies,
									true
								);
							} else {
								return formatNumber(
									Number(value),
									data?.CompanyCurrencies
								);
							}
						}}
					/>
				)}
				<Column
					title="Created Date"
					dataIndex="createdAt"
					key="createdAt"
					className="bg-white"
					render={(value: any) =>
						formatDate(
							value,
							data?.companyDateFormat ?? 'DD/MM/YYYY'
						)
					}
				/>

				<Column
					title="Notes"
					dataIndex="notes"
					className="bg-white"
					key="notes"
					// sorter={true}
					render={(text, record: { id: string }) =>
						invalidText(text) ? (
							'-'
						) : (
							<Ellipse
								message={text}
								maxLength={20}
								key={record.id}
								tooltipMessage={text}
								isTooltip={true}
							/>
						)
					}
				/>
				<Column
					title="Created By /Approved By"
					dataIndex="createdBy"
					className="bg-white"
					key="createdBy"
					render={(_, record: any) => record?.createdBy || '-'}
				/>
			</Table>
		</div>
	);
};

export default SalaryTable;
